import { render, staticRenderFns } from "./newTemplete.vue?vue&type=template&id=21c9b15c&scoped=true&"
import script from "./newTemplete.vue?vue&type=script&lang=js&"
export * from "./newTemplete.vue?vue&type=script&lang=js&"
import style0 from "./newTemplete.vue?vue&type=style&index=0&id=21c9b15c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c9b15c",
  null
  
)

export default component.exports